import type { SampleRule } from "@unbox/api";
import { Edit01, Trash01 } from "@untitledui/icons";
import { Badge } from "@/components/base/badges/badges";
import { Button } from "@/components/base/buttons/button";

interface RuleListRowProps {
  rule: SampleRule;
  onEdit: () => void;
  onDelete: () => void;
}

export function RuleListRow({ rule, onEdit, onDelete }: RuleListRowProps) {
  return (
    <div className="flex flex-row items-center justify-between gap-3 py-3">
      <div className="flex flex-col gap-1 min-w-0">
        <span className="text-sm font-medium text-primary truncate">{rule.name}</span>
        <span className="text-xs text-tertiary">
          {rule.action === "approve" ? "Auto-approves" : "Auto-ignores"} {rule.matchedCount} pending request
          {rule.matchedCount === 1 ? "" : "s"}
        </span>
      </div>
      <div className="flex flex-row items-center gap-2 shrink-0">
        <Badge type="pill-color" size="sm" color={rule.isActive ? "success" : "gray"}>
          {rule.isActive ? "Enabled" : "Disabled"}
        </Badge>
        <Button color="secondary" size="sm" iconLeading={Edit01} onClick={onEdit}>
          Edit
        </Button>
        <button
          type="button"
          className="p-1.5 rounded text-quaternary hover:text-error-primary hover:bg-primary_hover transition-colors"
          onClick={onDelete}
          aria-label={`Delete ${rule.name}`}
        >
          <Trash01 className="size-4" />
        </button>
      </div>
    </div>
  );
}
